import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLsConfig } from '../URLsConfig';
import { DemographicModel } from '../models/DemographicModel';
@Injectable()
export class DemographicService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getDemo(patientCode: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<DemographicModel>(this.urlsconfig.WebAPIURL_Test + 'api/Demographic/GetDemo',options);
    }
    public AddDemo(Demo: DemographicModel) {
      console.log("Demo:"+ Demo);
        return this.http.post<DemographicModel>(this.urlsconfig.WebAPIURL_Test + 'api/Demographic/AddDemo', Demo);
    }
    public delDemo(patientCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.delete<DemographicModel>(this.urlsconfig.WebAPIURL_Test + 'api/Demographic/DeleteDemo',options);
    }


}
